import {
  subtype as s,
  subtypeCatalog as c,
  withSubtypeImages as withImages,
} from './catalog-builder';

export const OBJECT_PRODUCT_SUBTYPE_CATALOGS = [
  c(
    'phone-case',
    ['Phone Case'],
    withImages('phone-case', [
      s('slim-shell', 'Slim shell', 'thin back shell', 'open front face'),
      s(
        'bumper',
        'Bumper',
        'reinforced perimeter frame',
        'open or clear back area'
      ),
      s('rugged', 'Rugged', 'thick protective shell', 'reinforced corners'),
      s('folio', 'Folio', 'device cradle', 'hinged front cover'),
      s('wallet', 'Wallet', 'device cradle', 'integrated card storage'),
      s('battery', 'Battery', 'protective shell', 'expanded battery housing'),
      s(
        'kickstand',
        'Kickstand',
        'protective shell',
        'integrated folding stand'
      ),
      s('flip', 'Flip', 'device cradle', 'vertically hinged front cover'),
      s(
        'holster',
        'Holster',
        'protective case',
        'external belt-mounted cradle'
      ),
      s(
        'armband',
        'Armband',
        'device pocket or cradle',
        'integrated arm strap'
      ),
      s(
        'lanyard',
        'Lanyard',
        'protective shell',
        'attached neck or wrist cord'
      ),
      s(
        'grip-case',
        'Grip case',
        'protective shell',
        'integrated rear hand grip'
      ),
    ])
  ),
  c(
    'notebook',
    ['Notebook'],
    withImages('notebook', [
      s(
        'hardcover',
        'Hardcover',
        'rigid front and back boards',
        'bound page block'
      ),
      s('softcover', 'Softcover', 'flexible outer cover', 'bound page block'),
      s(
        'spiral-bound',
        'Spiral-bound',
        'wire or coil spine',
        'individually punched pages'
      ),
      s(
        'lay-flat',
        'Lay-flat',
        'binding opens fully flat',
        'paired page spreads'
      ),
      s('pocket', 'Pocket', 'small portable page size', 'compact bound cover'),
      s(
        'journal',
        'Journal',
        'bound writing pages',
        'personal notebook proportions'
      ),
      s('planner', 'Planner', 'dated or structured page system', 'bound cover'),
      s(
        'composition',
        'Composition',
        'fixed sewn or glued spine',
        'standard school-book proportions'
      ),
      s(
        'travelers',
        'Traveler’s',
        'wraparound cover',
        'replaceable slim inserts'
      ),
      s(
        'ring-bound',
        'Ring-bound',
        'opening ring mechanism',
        'removable punched pages'
      ),
      s(
        'refillable',
        'Refillable',
        'reusable outer cover',
        'replaceable page block'
      ),
    ])
  ),
  c(
    'toys',
    ['Toys'],
    withImages('toys', [
      s('plush', 'Plush', 'soft stuffed body', 'sewn dimensional form'),
      s(
        'building-set',
        'Building set',
        'multiple connectable pieces',
        'repeatable connection system'
      ),
      s(
        'stacking',
        'Stacking',
        'multiple graduated pieces',
        'stable stacking relationship'
      ),
      s(
        'figurine',
        'Figurine',
        'single character or creature form',
        'freestanding small scale'
      ),
      s(
        'vehicle',
        'Vehicle',
        'recognizable vehicle body',
        'rolling or vehicle-like base'
      ),
      s(
        'puzzle',
        'Puzzle',
        'multiple interlocking pieces',
        'complete assembled target'
      ),
      s(
        'pretend-play-set',
        'Pretend-play set',
        'role-play objects',
        'coordinated multi-piece set'
      ),
      s(
        'doll',
        'Doll',
        'humanlike or character body',
        'poseable or dressed figure form'
      ),
      s('pull-along', 'Pull-along', 'wheeled toy body', 'front pull cord'),
      s(
        'musical',
        'Musical',
        'playable sound controls',
        'child-operated instrument body'
      ),
      s(
        'sensory',
        'Sensory',
        'multiple tactile elements',
        'hand-scale interactive form'
      ),
      s(
        'activity-toy',
        'Activity toy',
        'multiple interactive stations',
        'self-contained play body'
      ),
    ])
  ),
] as const;
